/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-09 14:40:12
 * @LastEditors: caiqin.xie
 * @message: 搜索结果列表
 */
import React from "react";
import BlogItem from '../../../components/BlogItem';
import styles from "../../index.module.scss";
import { IBlogItem } from "@/common/types";

interface IProps {
  ctry: string;
  device: string;
  blogList: IBlogItem[]; // 当前页的博客列表
  allBlogList: IBlogItem[]; // 所有博客列表
}

const ResultList = (props:IProps) => {
  const {ctry, device, blogList, allBlogList} = props
  const list = device=== "pc" ? blogList : allBlogList
  return (
    <>
      {/* 搜索结果*/}
      {list.map((item, index) => (
        <a
          href={`/${ctry}/blog/${item.seoUrl}`}
          key={item.id}
          className={styles['link-blog']}>
          <BlogItem
            type='normal'
            blogData={item}
            className={styles['custom-blog']}
            picClassName={styles['custom-blog-pic']}
            itemClassName={styles['custom-blog-item']} />
        </a>
      ))}
    </>
  )
}
export default ResultList
